import { useNewSpaceGate } from 'hooks/use-new-space-gate';
import { SpaceDrawMode } from 'utils/space-draw-mode';
import GridModeToolbar from './grid-mode-toolbar';
import {
  isSpaceDrawModeDisabled,
  SPACE_DRAW_MODE_TOOLBAR_ITEMS
} from './space-draw-mode-toolbar-items';

type SpaceDrawModeToolbarProps = Readonly<{
  mode: SpaceDrawMode;
  onChange: (mode: SpaceDrawMode) => void;
}>;

export default function SpaceDrawModeToolbar({
  mode,
  onChange
}: SpaceDrawModeToolbarProps) {
  const { isBlocked, reason } = useNewSpaceGate();

  return (
    <GridModeToolbar
      mode={mode}
      items={SPACE_DRAW_MODE_TOOLBAR_ITEMS}
      idPrefix='space-draw-mode'
      onChange={onChange}
      isItemDisabled={(itemMode) =>
        isSpaceDrawModeDisabled(itemMode, isBlocked)
      }
      disabledTooltip={reason}
    />
  );
}
